import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { Experiment } from "../../lib/types";

export type ExperimentGroupDraft = {
	id?: string;
	name: string;
	externalId: string;
	isFallback: boolean;
};

export type ExperimentDraft = {
	title: string;
	externalId: string;
	groups: ExperimentGroupDraft[];
};

export const useExperiments = () =>
	useQuery({
		queryKey: ["experiments"],
		queryFn: () => api.get<{ items: Experiment[] }>("/api/experiments"),
	});

export const useSaveExperiment = (experimentId: string | null) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (draft: ExperimentDraft) =>
			experimentId
				? api.put<{ experiment: Experiment }>(`/api/experiments/${experimentId}`, draft)
				: api.post<{ experiment: Experiment }>("/api/experiments", draft),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["experiments"] }),
	});
};

export const useDeleteExperiment = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (experimentId: string) => api.remove<undefined>(`/api/experiments/${experimentId}`),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["experiments"] }),
	});
};
